import { Navigate, useLocation } from "react-router-dom"

import { NotAllowed } from "../../../../components/PermissionGate/NotAllowed.tsx"
import { useAppSelector } from "../../../../hooks/use-app-selector.ts"
import { getLandingProjectTab } from "../../helpers/project-visible-tabs.ts"

export function ProjectDefaultSectionRedirect() {
  const permissions = useAppSelector(
    (state) => state.auth.permissions?.codes?.projects
  )
  const roleId = useAppSelector((state) => state.auth.userInfo?.role?.id)
  // A link into the project (a suggestion to review, the status history to
  // open) rides the query string, which the landing tab must keep.
  const { search } = useLocation()

  const firstVisibleTab = getLandingProjectTab(permissions, roleId)

  if (!firstVisibleTab) return <NotAllowed />

  return <Navigate to={{ pathname: firstVisibleTab, search }} replace />
}
